var _style, _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledDevicePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_1140_1704_00000002360991194674598980000006117709291532567684_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#939393;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 14,
    height: 24
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 14,
    height: 24,
    id: "mask0_1140_1704_00000002360991194674598980000006117709291532567684_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.3,5h3.5h1.7h0.7h3.4c0.6,0,1.2,0.4,1.2,1v20c0,0.5-0.5,1-1.2,1h-9.3c-0.6,0-1.2-0.4-1.2-1V6 C10.2,5.4,10.7,5,11.3,5z M17.2,5c0,0-0.1,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1-0.1,0.1-0.1C17.4,5.1,17.4,5,17.2,5H20 c0,0.6-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1h2.8c0,0-0.1,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.1h1.7c0.1,0,0.1-0.1,0.1-0.1 c0-0.1,0-0.1-0.1-0.1H17.2z M9,6c0-1.1,1-2,2.3-2h9.3C22,4,23,4.9,23,6v20c0,1.1-1,2-2.3,2h-9.3C10,28,9,27.1,9,26V6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledDevicePhone);
export default __webpack_public_path__ + "static/media/disabled-device-phone.300e83c56fd1d149bae24d333a1fe983.svg";
export { ForwardRef as ReactComponent };